import { useRef } from "react"
import { useVideoPlaybackTracking } from "../../hooks/useVideoPlaybackTracking"
import { useViewMediaDiscovery } from "../../hooks/useViewMediaDiscovery"

const VideoPlayer = ({
  video,
  source,
  trackingIds,
  enabled,
  title,
  enqueueEvent,
}) => {
  const iframeRef = useRef(null)

  useVideoPlaybackTracking({
    iframeRef,
    videoId: video.VideoId,
    source,
    trackingIds,
    enabled,
    enqueueEvent,
  })

  // TEMP (ViewMedica discovery): dev and staging only, see the hook.
  useViewMediaDiscovery({ iframeRef, videoId: video.VideoId })

  return (
    <iframe
      ref={iframeRef}
      allowFullScreen
      allow="autoplay; encrypted-media; picture-in-picture; fullscreen; clipboard-write;"
      className="w-full h-full"
      frameBorder="0"
      loading="lazy"
      referrerPolicy="origin"
      src={video.VideoLink}
      title={title}
    />
  )
}

export default VideoPlayer
